import { render, staticRenderFns } from "./AmalgamationSingleResolution.vue?vue&type=template&id=9e7e33de&scoped=true&"
import script from "./AmalgamationSingleResolution.vue?vue&type=script&lang=js&"
export * from "./AmalgamationSingleResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7e33de",
  null
  
)

export default component.exports